<template>
  <nav class="navbar navbar-expand-lg fixed-top" :class="{ 'scrolled': isScrolled }">
    <div class="container align-items-center nav-container-line">
      <a class="navbar-brand" href="#" aria-label="Inicio" @click.prevent="scrollToTop">
        <img src="@/assets/IMG/LOGO.png" alt="NFCare logo" class="nfcare-logo" style="height:40px;" />
      </a>

      <div class="navbar-collapse desktop-only" id="MENU">
        <ul class="navbar-nav ms-0 menu-left">
          <li v-for="menu in menus" :key="menu.id" class="nav-item">
            <a :href="menu.url" class="nav-link" v-text="menu.name"></a>
          </li>
        </ul>
      </div>

      <button
        class="btn btn-burger mobile-only burger-center"
        type="button"
        @click="toggleMenu"
        :aria-expanded="isOpen ? 'true' : 'false'"
        aria-label="Abrir menú"
      >
        <i class="bi" :class="isOpen ? 'bi-x-lg' : 'bi-list'"></i>
      </button>

      <div class="nav-actions ms-auto d-flex align-items-center">
        <a href="#" class="thumbnail" aria-label="Colombia">
          <img src="@/assets/IMG/colombia.jpeg" alt="Bandera de Colombia" />
        </a>

        <button class="btn btn-arrow" @click="redireccion()" aria-label="Ir a login">
          <img src="@/assets/IMG/Flecha.png" alt="Flecha" class="arrow-img" />
        </button>
      </div>

      <!-- overlay -->
      <div v-show="isOpen" class="menu-overlay" @click="closeMenu"></div>

      <!-- menu -->
      <transition name="menu-pop">
        <div v-if="isOpen" class="mobile-wrap mobile-only" role="menu">
          <div class="mobile-menu">
            <ul class="mobile-list">
              <li v-for="menu in menus" :key="menu.id" class="mobile-item">
                <a class="mobile-link" :href="menu.url" @click.prevent="goTo(menu.url)">
                  {{ menu.name }}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </transition>
    </div>
  </nav>
</template>

<script>
export default {
  name: "MenuView",
  data() {
    return {
      isOpen: false,
      isScrolled: false,
      menus: [
        { id: 1, name: "NOSOTROS", url: "#identification" },
        { id: 2, name: "BENEFICIOS", url: "#card" },
        { id: 3, name: "SOLUCIONES", url: "#soluciones" },
        { id: 4, name: "CONTACTO", url: "#contacto" },
      ],
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, { passive: true });
    window.addEventListener("resize", this.handleResize, { passive: true });
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
    window.removeEventListener("resize", this.handleResize);
    this.unlockScroll();
  },
  methods: {
        scrollToTop() {
          window.scrollTo({ top: 0, behavior: "smooth" });
        },
    handleScroll() {
      this.isScrolled = window.scrollY > 0;
    },
    handleResize() {
      // Si pasas a desktop, cierra el menú (evita estados raros en iPad rotando)
      if (window.innerWidth >= 992 && this.isOpen) this.closeMenu();
    },
    lockScroll() {
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
    },
    unlockScroll() {
      document.documentElement.style.overflow = "";
      document.body.style.overflow = "";
    },
    toggleMenu() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) this.lockScroll();
      else this.unlockScroll();
    },
    closeMenu() {
      this.isOpen = false;
      this.unlockScroll();
    },
    redireccion() {
      window.location.href = "/login_usuarios.html";
    },
    goTo(hash) {
      this.closeMenu();
      // Espera a que el elemento esté en el DOM (útil para SPA)
      const scrollToHash = () => {
        const el = document.querySelector(hash);
        if (!el) {
          if (scrollToHash.attempts < 10) {
            scrollToHash.attempts++;
            setTimeout(scrollToHash, 50);
          } else {
            window.location.hash = hash;
          }
          return;
        }
        // Scroll exacto al inicio de la sección, compensando el navbar (sin scrollIntoView)
        const nav = document.querySelector('.navbar');
        const navH = nav ? nav.offsetHeight : 0;
        const y = el.getBoundingClientRect().top + window.pageYOffset - navH;
        window.scrollTo({ top: y, behavior: 'smooth' });
      };
      scrollToHash.attempts = 0;
      scrollToHash();
    },
  },
};
</script>

<style scoped>
/* Subir z-index de navbar para evitar que otros elementos tapen el menú */
.navbar { z-index: 10000; }

/* Marca NFCare en vez de logo */
.nfcare-brand {
  color: #004b5c;
  font-size: 1.45rem;
  font-weight: 400;
  letter-spacing: 0.5px;
  font-family: Helvetica, Arial, sans-serif !important;
}
.navbar {
  background: #fff !important;
  padding: 18px 0 0 0;
  min-height: 90px;
  transition: background 300ms ease, box-shadow 300ms ease;
  font-family: Helvetica, Arial, sans-serif !important;
}

.navbar.scrolled {
  background: #fff !important;
  box-shadow: 0 4px 12px rgba(62, 109, 176, 0.12);
}

.nav-container-line {
  position: relative;
  display: grid;
  grid-template-columns: auto 1fr auto;
  align-items: center;
  column-gap: clamp(10px, 1.2vw, 18px);
  padding-top: 0;
  padding-bottom: 0;
}

.nav-container-line::after {
  content: "";
  position: absolute;
  height: 2px;
  background: #004b5c;
  border-radius: 999px;
  bottom: -1px;
  left: 0;
  right: 0;
  z-index: 1;
}

.navbar-brand {
  grid-column: 1;
  padding: 0;
  margin: 0;
  position: relative;
  z-index: 2;
}

.navbar-collapse.desktop-only {
  grid-column: 2;
  justify-self: center;
  display: flex;
  justify-content: center;
}

.menu-left {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: clamp(26px, 4vw, 74px);
  margin: 0;
  padding: 0;
}

.navbar-nav .nav-link {
  color: #004b5c !important;
  white-space: nowrap;
  padding: 5px 8px;
  line-height: 1.1;
  font-size: clamp(18px, 1.9vw, 27px);
  text-align: center;
  font-family: Helvetica, Arial, sans-serif !important;
  font-weight: 400;
  letter-spacing: 0.25px;
  text-transform: uppercase;
  border-radius: 999px;
  transition: background 160ms ease, opacity 160ms ease, transform 160ms ease;
}

.navbar-nav .nav-link:hover {
  background: rgba(62, 109, 176, 0.1);
  color: #303030 !important;
  transform: translateY(-1px);
}

.nav-actions {
  grid-column: 3;
  justify-self: end;
  gap: 8px;
  position: relative;
  z-index: 2;
}

.thumbnail {
  display: inline-flex;
  align-items: center;
}

.thumbnail img {
  width: 42px;
  height: 32px;
  border-radius: 8px;
  display: block;
}

.btn-arrow {
  background: transparent !important;
  padding: 4px 8px;
  border-radius: 12px;
  line-height: 1;
  transition: transform 160ms ease, background 160ms ease, border-color 160ms ease;
}

.btn-arrow .arrow-img {
  width: 34px;
  height: 34px;
  display: block;
  filter: brightness(0) saturate(100%) invert(18%) sepia(99%) saturate(747%) hue-rotate(153deg) brightness(97%) contrast(101%);
}

.btn-arrow:hover {
  background: rgba(62, 109, 176, 0.1);
  border-color: rgba(62, 109, 176, 0.35);
  transform: translateY(-1px);
}

.btn-burger {
  grid-column: 2;
  justify-self: center;
  background: rgba(62, 109, 176, 0.1) !important;
  border: 1px solid rgba(62, 109, 176, 0.35);
  padding: 5px 9px;
  border-radius: 12px;
  line-height: 1;
  transition: transform 180ms ease, background 160ms ease, border-color 160ms ease;
  position: relative;
  z-index: 3;
}

.btn-burger i {
  color: #3e6db0;
  font-size: 18px;
  transition: transform 180ms ease, opacity 180ms ease;
}

.btn-burger:hover {
  background: rgba(62, 109, 176, 0.18) !important;
  border-color: rgba(62, 109, 176, 0.45);
  transform: translateY(-1px);
}

.btn-burger[aria-expanded="true"] i {
  transform: rotate(90deg) scale(1.02);
}

.burger-center {
  position: static;
  left: auto;
  top: auto;
  transform: none;
}

/* Overlay */
.menu-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.22);
  backdrop-filter: blur(2px);
  z-index: 9998;
}

/* ✅ Mobile menu wrapper para animación y centrado */
.mobile-wrap {
  position: fixed;
  left: 50%;
  top: 74px;
  transform: translateX(-50%);
  z-index: 9999;
  width: min(340px, 92vw);
  transform-origin: top center;
}

/* Panel del menú móvil */
.mobile-menu {
  width: 100%;
  padding: 14px 14px 12px;
  background: #efefe4;
  border: none;
  border-radius: 14px;
  backdrop-filter: blur(8px);
  box-shadow: 0 14px 40px rgba(62, 109, 176, 0.2);
}

.mobile-list {
  list-style: none;
  margin: 0;
  padding: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 14px;
  text-align: center;
}

.mobile-link {
  display: block;
  width: 100%;
  text-align: center;
  padding: 8px 10px;
  background: transparent;
  border: none;
  border-radius: 0;
  color: #004b5c;
  text-decoration: none;
  font-family: Helvetica, Arial, sans-serif !important;
  font-weight: 400;
  font-size: 12.5px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  transition: opacity 160ms ease, transform 180ms ease;
}

.mobile-link:hover {
  opacity: 0.85;
  color: #303030;
  transform: translateY(-1px);
}

/* Animación vertical pura (barrido tipo acordeón) */
.menu-pop-enter-active,
.menu-pop-leave-active {
  transition: max-height 320ms cubic-bezier(.4,0,.2,1);
  overflow: hidden;
}
.menu-pop-enter-from,
.menu-pop-leave-to {
  max-height: 0;
}
.menu-pop-enter-to,
.menu-pop-leave-from {
  max-height: 600px;
}

.desktop-only { display: flex; }
.mobile-only { display: none; }

@media (max-width: 991px) {
  .desktop-only { display: none !important; }
  .mobile-only { display: inline-flex !important; }

  .navbar { padding: 6px 0 2px; }

  .btn-burger {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }

  .btn-burger:hover {
    transform: translate(-50%, calc(-50% - 1px));
  }

  .nav-actions { gap: 6px; }

  .nav-container-line::after { bottom: -10px; }

  .mobile-wrap { top: 68px; width: min(360px, 94vw); }
  .mobile-link { font-size: 13px; }
}

@media (max-width: 480px) {
  .navbar { padding: 2px 0 0px; }

  .thumbnail img { width: 28px; height: 20px; }
  .btn-arrow .arrow-img { width: 22px; height: 22px; }

  .nav-container-line::after { bottom: -12px; }

  .mobile-wrap { top: 64px; width: min(300px, 94vw); }
  .mobile-link { font-size: 12.5px; }
}

/* iPad (768–1024): estilos generales */
@media (min-width: 768px) and (max-width: 1024px) {
  .navbar { padding: 10px 0 6px; }
  .menu-left { gap: clamp(12px, 2vw, 24px); }
  .navbar-nav .nav-link {
    font-size: clamp(13px, 1.2vw, 18px);
    padding: 4px 6px;
    letter-spacing: 0.12px;
  }
  .nfcare-brand { font-size: 1.1rem; }
  .thumbnail img { width: 24px; height: 18px; }
  .btn-arrow .arrow-img { width: 18px; height: 18px; }
}
/* Ajuste vertical del logo en el menú */
.nfcare-logo {
  height: 40px;
  margin-top: -20px;
  /* Puedes ajustar el valor de margin-top según lo que necesites */
}

/* iPad “pequeño” (<=899): muestra burger */
@media (min-width: 768px) and (max-width: 899px) {
  .desktop-only { display: none !important; }
  .mobile-only { display: inline-flex !important; }
  
}
</style>

